import { NotificationConfiguration } from '../notification.templates';

export const CONNECT_USER_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> has connected your accounts.`,
  email: {
    ctaKey: 'go_to_settings',
  },
};
